"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KTNDetailsStatusEnum = exports.KTNDetailsToJSON = exports.KTNDetailsFromJSONTyped = exports.KTNDetailsFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function KTNDetailsFromJSON(json) {
    return KTNDetailsFromJSONTyped(json, false);
}
exports.KTNDetailsFromJSON = KTNDetailsFromJSON;
function KTNDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': _1.NameObjectFromJSON(json['name']),
        'determinationStatus': json['determinationStatus'],
        'ktn': !runtime_1.exists(json, 'ktn') ? undefined : json['ktn'],
        'expirationDate': !runtime_1.exists(json, 'expirationDate') ? undefined : (new Date(json['expirationDate'])),
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
    };
}
exports.KTNDetailsFromJSONTyped = KTNDetailsFromJSONTyped;
function KTNDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': _1.NameObjectToJSON(value.name),
        'determinationStatus': value.determinationStatus,
        'ktn': value.ktn,
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate.toISOString().substr(0, 10)),
        'status': value.status,
    };
}
exports.KTNDetailsToJSON = KTNDetailsToJSON;
/**
* @export
* @enum {string}
*/
var KTNDetailsStatusEnum;
(function (KTNDetailsStatusEnum) {
    KTNDetailsStatusEnum["ELIGIBLEFORRENEWAL"] = "ELIGIBLE_FOR_RENEWAL";
    KTNDetailsStatusEnum["INPROGRESS"] = "IN_PROGRESS";
    KTNDetailsStatusEnum["COMPLETED"] = "COMPLETED";
    KTNDetailsStatusEnum["NOTELIGIBLEFORRENEWAL"] = "NOT_ELIGIBLE_FOR_RENEWAL";
})(KTNDetailsStatusEnum = exports.KTNDetailsStatusEnum || (exports.KTNDetailsStatusEnum = {}));
//# sourceMappingURL=KTNDetails.js.map